import React, { useRef } from "react"
import useFormField from "../../../../hooks/useFormField"
import FormInputLabel from "../labels/form-field-label"
import FormFieldError from "../labels/form-field-error"
import ToggleInfo from "../buttons/toggle-info-button"

export default function CheckboxGroupInput({
  name,
  id,
  options = [],
  label,
  description,
  required,
  validateField,
  globalValue,
  displayOption,
  setGlobalValue,
  error,
  setError,
  isPermissionInput = false,
  permissionText = "",
  closeModalLabel,
  moreInfoLabel,
}) {
  const checkedOptions = options.filter((option) => option.checked)
  const preValue = checkedOptions.length > 0 ? checkedOptions.map((option) => option.value) : undefined
  const { value, handleFocus, isFocused, handleCheckboxBlur } = useFormField(preValue, validateField, globalValue, setGlobalValue, setError)

  const wrapperRef = useRef(null)

  const handleMouseDown = (e) => {
    // Prevent blur when clicking inside the component
    if (wrapperRef.current && wrapperRef.current.contains(e.target)) {
      e.preventDefault()
    }
  }

  const handleCheckboxChange = (e) => {
    let newValue
    if (value == undefined) {
      newValue = [e.target.value]
    } else {
      newValue = e.target.checked ? [...value, e.target.value] : value.filter((val) => val !== e.target.value)
    }
    setGlobalValue(newValue)
  }

  return (
    <div
      className={`form-element form-element--choice__multi is-filled Form__Element ${isPermissionInput ? "permission" : ""} ${displayOption} ${required ? "is-required" : ""} ${isFocused ? "has-focus" : ""} ${error ? "is-invalid" : ""}`}
      data-f-element-name={name}
      data-f-type="choice"
      title={description}
      aria-label={description}
    >
      {label && (
        <div className="form-labels">
          <FormInputLabel id={id} label={label} required={required} />
          <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
        </div>
      )}
      <div className="choice-wrapper" ref={wrapperRef} onMouseDown={handleMouseDown} id={id}>
        {options.map((option, index) => (
          <div key={index} className="form-input choice-item">
            <label className="form-label">
              <input
                type="checkbox"
                name={name}
                value={option.value}
                defaultChecked={option.checked}
                onChange={handleCheckboxChange}
                onFocus={handleFocus}
                onBlur={() => handleCheckboxBlur(value)}
                className="form-input--checkbox"
                data-f-datainput=""
                aria-required={required}
                required={required}
              />
              {isPermissionInput ? (
                <div className="permission-choice">
                  <span className="form-label__text">{option.label}</span>
                  {permissionText ? "" : <span className="form-label__text form-label__text--value">{option.value}</span>}
                </div>
              ) : (
                <span className="form-label__text">{option.label}</span>
              )}
            </label>
            {permissionText ? (
              <div className="permission-text">
                <span className="form-label__text form-label__text--value rich-text" dangerouslySetInnerHTML={{ __html: permissionText }}></span>
              </div>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
      <FormFieldError name={name} error={error} />
    </div>
  )
}
